import { z } from 'zod/v4';

export const AI_CALL_END_REASONS = [
  'customer_did_not_answer',
  'customer_ended_call',
  'assistant_ended_call',
  'silence_timed_out',
  'vonage_rejected',
  'vonage_completed',
] as const;

export type AiCallEndReason = (typeof AI_CALL_END_REASONS)[number];

export const AiCallEndReasonSchema = z.enum([...AI_CALL_END_REASONS]);
